import { requst } from '../config'

// 日历上数据
export const getAcquisitionCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/acquisition/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getAcquisitionDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 获取所有 sps 文件列表
export const getPreplotSListApi = projectId => {
    const url = `/setting/preplot/getAcquisitionList/${projectId}`
    return requst.get(url)
}

// 获取所有 p190 文件列表
export const getPreplotPListApi = projectId => {
    const url = `/setting/preplot/getStreamerList/${projectId}`
    return requst.get(url)
}

// 获取磁重力 里程km
export const getPreplotPKMApi = preplotId => {
    const url = `/setting/preplot/${preplotId}`
    return requst.get(url)
}

// 询数据库中相同preplotLine数量
export const getcountPreplotLineApi = (preplotLine, projectId, type, sequence, constructionType) => {
    const url = `/monitor/acquisition/streamer/countPreplotLine?projectId=${projectId}&preplotLine=${preplotLine}&type=${type}&sequence=${sequence}&constructionType=${constructionType}`
    return requst.get(url)
}

// 获取文件所有线, id 是文件的 id
export const getPreplotLinesApi = id => {
    const url = `/setting/preplot/queryDetail?fkPreplotId=${id}`
    return requst.get(url)
}

// 查询日期
export const getAcquisitionByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/acquisition/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getAcquisitionByIdApi = id => {
    const url = `/monitor/acquisition/${id}`
    return requst.get(url)
}

// 获取 Activities 数据
export const getAcquisitionActivitiesDataApi = id => {
    const url = `/monitor/acquisition/activity/list?acquisitionId=${id}`
    return requst.get(url)
}

// 提交 Acquisition 总结
export const postAcquisitionCommentApi = commentData => {
    const url = `/monitor/acquisition`
    return requst.post(url, { ...commentData })
}

// 修改 Acquisition 总结
export const putAcquisitionCommentApi = (commentData, id) => {
    const url = `/monitor/acquisition`
    return requst.put(url, { ...commentData, id })
}

// 提交 Activities 数据
export const postAcquisitionActivitiesDataApi = (activitiesParams, id) => {
    const url = `/monitor/acquisition/activity/addOrUpdateBatch/${id}`
    return requst.post(url, activitiesParams)
}

// 获取 Activities 总炮数据
export const postAcquisitionAllShotsApi = (shotsParams) => {
    const url = `/monitor/acquisition/activity/calculateFLPTotal`
    return requst.post(url, shotsParams)
}

// 提交 streamer 数据
export const postAcquisitionstreamerDataApi = (streamerParams, id) => {
    const url = `/monitor/acquisition/streamer/addOrUpdate`
    return requst.post(url, streamerParams)
}

// 提交 streamer 重磁力 数据
export const postAcquisitionstreamerMagnetismDataApi = (streamerParams, id) => {
    const url = `/magneticGravity/save`
    return requst.post(url, streamerParams)
}

// 获取 streamer 列表数据
export const getAcquisitionstreamerDataApi = (locationId, projectId) => {
    const url = `/monitor/acquisition/streamer/list?locationId=${locationId}&projectId=${projectId}`
    return requst.get(url)
}

// 获取 streamer  根据选中p190文件的id 获取线名数据
export const getAcquisitionstreamerLineDataApi = (id) => {
    const url = `/setting/preplot/queryLines/${id}`
    return requst.get(url)
}

// 获取 streamer 重磁力 列表数据
export const getAcquisitionstreamerMagnetismDataApi = (locationId, projectId) => {
    const url = `/magneticGravity/list?locationId=${locationId}&projectId=${projectId}`
    return requst.get(url)
}

// 获取 streamer 重磁力 类型列表
export const getAcquisitionstreamerMagnetismDataTypeApi = (locationId, projectId) => {
    const url = `/magneticGravityItem/listType`
    return requst.get(url)
}

// 导入 streamer 拖缆数据 向 重磁力
export const getImportantMagnetismDataTypeApi = (projectId) => {
    const url = `/magneticGravity/importFromStreamer?projectId=${projectId}`
    return requst.get(url)
}

// 获取 streamer 详情
export const getAcquisitionstreamerDetailApi = id => {
    const url = `/monitor/acquisition/streamer/getInfo/${id}`
    return requst.get(url)
}

// 获取 streamer 重磁力 详情
export const getAcquisitionstreamerMagnetismDetailApi = id => {
    const url = `/magneticGravity/getById?id=${id}`
    return requst.get(url)
}

// 获取 streamer 详情
export const deleteAcquisitionstreamerDetailApi = id => {
    const url = `/monitor/acquisition/streamer/delete/${id}`
    return requst.delete(url)
}

// 删除 磁重力 详情
export const deleteMagnetismDetailApi = id => {
    const url = `/magneticGravity/delete?id=${id}`
    return requst.delete(url)
}
